/**
 * 검토보고서 이력 API — 발급(PDF/이메일) 시 자동 저장 + '내 검토보고서' 목록·재발급.
 * savedCasesApi 미러(인증 헤더 공용). 저장은 fire-and-forget(발급 UX 비차단).
 *   GET  list         → [{report_id, product_name, decided_hsk, issued_via, to_email, created_at, updated_at}]
 *   GET  /{id}        → {report_id, ..., report:{...reportData 스냅샷...}}  (재발급용)
 *   POST save(upsert) → 보고서당 1건(report_id 로 dedup)
 *   DELETE /{id}
 */
function token() {
  return localStorage.getItem("token") || sessionStorage.getItem("token") || "";
}
export function isLoggedIn() {
  return !!token();
}
function authHeaders(json) {
  const h = {};
  const t = token();
  if (t) h.Authorization = `Bearer ${t}`;
  if (json) h["Content-Type"] = "application/json";
  return h;
}

const BASE = "/api/onto/report/classify/history";

// 모달 1회 발급 세션당 report_id 1개(다운로드·이메일 = 보고서당 1건 upsert).
export function newReportId() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  } catch {
    /* noop */
  }
  return `r-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
}

export async function fetchReportHistory() {
  if (!isLoggedIn()) return [];
  try {
    const r = await fetch(BASE, { headers: authHeaders() });
    if (!r.ok) return [];
    const d = await r.json();
    return Array.isArray(d.items) ? d.items : [];
  } catch {
    return [];
  }
}

export async function fetchReportOne(reportId) {
  if (!reportId) return null;
  try {
    const r = await fetch(`${BASE}/${encodeURIComponent(reportId)}`, { headers: authHeaders() });
    if (!r.ok) return null;
    return await r.json();
  } catch {
    return null;
  }
}

// 발급 시 자동 저장 — fire-and-forget. payload={report_id, product_name, decided_hsk, report, issued_via, to?}
export function saveReport(payload) {
  if (!isLoggedIn() || !payload || !payload.report_id || !payload.report) return;
  try {
    fetch(BASE, {
      method: "POST",
      headers: authHeaders(true),
      body: JSON.stringify(payload),
    }).catch(() => {});
  } catch {
    /* noop */
  }
}

export async function removeReport(reportId) {
  if (!reportId) return false;
  try {
    const r = await fetch(`${BASE}/${encodeURIComponent(reportId)}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    return r.ok;
  } catch {
    return false;
  }
}
